export enum HttpResponseStatusCodes {
  NotFound = 404,
  InternalServerError = 500,
}
